import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { FormattedMessage } from 'react-intl';
import { TileButton, TileButtonProps } from '@printdeal/ui-library';
import {
  dispatchAccountEvent,
  DispatchCategoriesAccount,
} from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import useSystemPages from '../../../../../../hooks/useSystemPages';

interface EditFilesButtonProps {
  lineItemId: string,
  orderId: string,
  dispatchEventCategory?: DispatchCategoriesAccount;
  thumbSize?: TileButtonProps['size'];
  thumbClasses?: string;
}

const OpenAlternativeUploadThumbButton = ({
  lineItemId,
  orderId,
  dispatchEventCategory = 'order_detail_interaction',
  thumbSize = 'lg',
  thumbClasses = '',
}: EditFilesButtonProps) => {
  const [accountDashboardPage] = useSystemPages('accountDashboard');

  return (
    <TileButton
      size={thumbSize}
      as={GatsbyLink}
      to={`${accountDashboardPage.path}/orders/${orderId ? `${orderId}/` : ''}upload/${lineItemId}`}
      icon="image"
      className={`${thumbClasses} pd-text-center`}
      onClick={() => { dispatchAccountEvent(dispatchEventCategory, 'open_alternative_upload'); }}
    >
      <FormattedMessage id="account.order.deliverFiles.button" defaultMessage="Click here to deliver your designs" />
    </TileButton>
  );
};

export default OpenAlternativeUploadThumbButton;
